import React from 'react';
import { Badge, BadgeProps } from '@chakra-ui/react';

interface OutlineBadgeProps extends BadgeProps {
	children: React.ReactNode;
	icon?: React.ReactNode;
	type?: 'button' | 'submit' | 'reset';
}

/**
 * Reusable outline badge for displaying tags and labels in the Bundle brand style.
 * Encapsulates the consistent outline/shadow styling so call sites stay clean.
 * Any BadgeProps can be passed to override the defaults (e.g. size, colorPalette).
 */
const OutlineBadge: React.FC<OutlineBadgeProps> = (props) => {
	const {
		children,
		icon,
		variant = 'outline',
		size = 'lg',
		fontSize = 'xs',
		borderRadius = 'full',
		borderColor = 'border.default',
		color = 'brand.fg',
		fontWeight = 'medium',
		bg = 'surface.default',
		...rest
	} = props;

	return (
		<Badge
			variant={variant}
			size={size}
			fontSize={fontSize}
			borderRadius={borderRadius}
			borderColor={borderColor}
			color={color}
			fontWeight={fontWeight}
			bg={bg}
			{...rest}
		>
			{icon}
			{children}
		</Badge>
	);
};

export default OutlineBadge;
